import * as React from 'react'
import {Suspense, useContext, useEffect, useState} from 'react'
import {useTranslation} from 'react-i18next'
import {api} from '../api/api'
import {AppContext} from '../app'
import ModalStatus from '../components/statusModal'
import '../css/contact.css'
import AppProps from '../util/appProps'
import { getCurrentLocale } from '../util/locales'
import {ACCENT_TEXT_FW500, tagger, setTitleFont} from '../util/util'

const UserAppAnimation = React.lazy(() => import('../lotties/user_app/userApp'))

const GetInTouch = (props: AppProps) => {

    const {utmParameters} = useContext(AppContext)

    const {t, i18n} = useTranslation('contact')
    const tCommon = useTranslation('common').t

    const statusModalData = {
        title: 'Message Sent',
        text: 'Your message has been recorded. We will reply as soon as possible.'
    }

    const getUserId = () => {
        const search = props.location.search
        const params = new URLSearchParams(search)
        return params.get('id')
    }

    useEffect(() => {
        const userId = getUserId()
        if (!userId) {
            props.history.push('/' + getCurrentLocale())
        }
        setTitleFont(i18n.language)    
    }, [])

    const [form, setForm] = useState({
        placement: 'getintouch',
        website: '',
        skype: '',
        phone: '',
        message: '',
        userId: getUserId(),
        utm: utmParameters || {}
    })
    const [eWebsite, setEWebsite] = useState<string[]>([])
    const [eSkype, setESkype] = useState<string[]>([])
    const [eMessage, setEMessage] = useState<string[]>([])

    const [statusModal, setStatusModal] = useState(false)

    const toggleStatusModal = () => setStatusModal(!statusModal)

    const updateErrors = (website, skype, message) => {
        setEWebsite(website)
        setESkype(skype)
        setEMessage(message)
    }

    const sendFormData = () => {
        updateErrors([], [], [])
        if (form.website && form.skype && form.message) {
            api.postContactFormData(JSON.stringify(form))
                .then(() => {
                    setForm({
                        ...form,
                        website: '',
                        skype: '',
                        phone: '',
                        message: ''
                    })
                    toggleStatusModal()
                })
        } else {
            updateErrors(
                form.website ? [] : [tCommon('required field')],
                form.skype ? [] : [tCommon('required field')],
                form.message ? [] : [tCommon('required field')]
            )
        }
    }

    return (
        <div className="common-pages-container contact">
            <ModalStatus data={statusModalData} show={statusModal} toggle={toggleStatusModal} />
            <div className="contact-left">
                <div className="title muli not-desktop not-mobile">{tagger(t('Get in Touch'), 'accent-text')}</div>
                <div className="get-in-t-l">
                    <div className="title muli not-tablet">{tagger(t('Get in Touch'), 'accent-text')}</div>
                    <div className="text">{tagger(t('Lets grow your userbase'), ACCENT_TEXT_FW500)}
                        <br className="not-desktop not-mobile" />
                        <br className="not-desktop not-mobile" />
                        <span className="get-in-tablet-span">{t('were looking forward')}</span>
                    </div>
                </div>
                <div className="lottie-user-app-container get-in-t-r">
                    <Suspense fallback="">
                        <UserAppAnimation />
                    </Suspense>
                </div>
            </div>
            <div className="contact-right">
                <div className="text mt-10 mb-35 not-mobile">{tagger(t('Fill in the form'), ACCENT_TEXT_FW500)}</div>
                <div className="contact-input-container">
                    <input className={'contact-input small-text' + (eWebsite.length > 0 ? ' error-input' : '')} type="input" name="app" placeholder="&nbsp;" value={form.website}
                        onChange={e => setForm({...form, website: e.currentTarget.value})} />
                    <span className="contact-input-label">{t('App / Website URL')}</span>
                </div>
                {eWebsite && eWebsite.map(err => <div className="error-small" key={err}>{err}</div>)}
                <div className="contact-input-container">
                    <input className={'contact-input small-text' + (eSkype.length > 0 ? ' error-input' : '')} type="input" name="skype" placeholder="&nbsp;" value={form.skype}
                        onChange={e => setForm({...form, skype: e.currentTarget.value})} />
                    <span className="contact-input-label">{t('Skype ID')}</span>
                </div>
                {eSkype && eSkype.map(err => <div className="error-small" key={err}>{err}</div>)}
                <div className="contact-input-container">
                    <input className="contact-input small-text" type="input" name="phone" placeholder="&nbsp;" value={form.phone}
                        onChange={e => setForm({...form, phone: e.currentTarget.value})} />
                    <span className="contact-input-label">{t('Phone number')}</span>
                </div>
                <div className="contact-input-area-container">
                    <textarea className={'contact-input contact-textarea small-text' + (eMessage.length > 0 ? ' error-input' : '')}
                        name="contactMessage" placeholder="&nbsp;" value={form.message}
                        onChange={e => setForm({...form, message: e.currentTarget.value})} />
                    <span className="contact-input-label">{t('Message')}</span>
                </div>
                {eMessage && eMessage.map(err => <div className="error-small" key={err}>{err}</div>)}
                <button className="button-blue large" onClick={sendFormData}>{tCommon('Send')}</button>
            </div>
        </div>
    )
}

export default GetInTouch



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/pages/getInTouch.tsx